import { createFileRoute } from "@tanstack/react-router";

import { NotesPage } from "@/modules/notes/pages/Notes.page";

export const Route = createFileRoute("/__authed/m/notes")({
	component: NotesPage,
});
